import BooleanIcon from '../../../assets/img/custom_field-boolean.svg';
import NumericalIcon from '../../../assets/img/custom_field-numerical.svg';
import TextIcon from '../../../assets/img/custom_field-text.svg';
import TimewindowsIcon from '../../../assets/img/custom_field-time_windows.svg';
import { SectionsProjectFieldProps } from './ProjectFields';

type ProjectFieldsConstraints = {
  weight: SectionsProjectFieldProps;
  volume: SectionsProjectFieldProps;
  time_windows: SectionsProjectFieldProps;
  provide_requires: SectionsProjectFieldProps;
  max_services: SectionsProjectFieldProps;
  pickups: SectionsProjectFieldProps;
  max_distance: SectionsProjectFieldProps;
  min_distance?: SectionsProjectFieldProps;
  max_time: SectionsProjectFieldProps;
  min_time?: SectionsProjectFieldProps;
  max_delivery_time: SectionsProjectFieldProps;
  reward: SectionsProjectFieldProps;
  cluster: SectionsProjectFieldProps;
};

export const getProjectFieldsConstraints = (isRootOrAdmin?: boolean): ProjectFieldsConstraints => {
  return {
    // NOT YET.
    // distance: {
    //   iconSrc: NumericalIcon
    //   description: `projects.settings.fields.constraints.distance.description`,
    // },
    weight: {
      iconSrc: NumericalIcon,
      description: `projects.settings.fields.constraints.weight.description`,
    },
    volume: {
      iconSrc: NumericalIcon,
      description: `projects.settings.fields.constraints.volume.description`,
    },
    time_windows: {
      iconSrc: TimewindowsIcon,
      description: `projects.settings.fields.constraints.time_windows.description`,
    },
    provide_requires: {
      iconSrc: BooleanIcon,
      description: `projects.settings.fields.constraints.provide_requires.description`,
    },
    max_services: {
      iconSrc: NumericalIcon,
      description: `projects.settings.fields.constraints.max_services.description`,
    },
    pickups: {
      iconSrc: BooleanIcon,
      description: `projects.settings.fields.constraints.pickups.description`,
    },
    max_distance: {
      iconSrc: NumericalIcon,
      description: `projects.settings.fields.constraints.max_distance.description`,
    },
    ...(isRootOrAdmin
      ? {
          min_distance: {
            iconSrc: NumericalIcon,
            description: `projects.settings.fields.constraints.min_distance.description`,
          },
        }
      : {}),
    max_time: {
      iconSrc: NumericalIcon,
      description: `projects.settings.fields.constraints.max_time.description`,
    },
    ...(isRootOrAdmin
      ? {
          min_time: {
            iconSrc: NumericalIcon,
            description: `projects.settings.fields.constraints.min_time.description`,
          },
        }
      : {}),
    max_delivery_time: {
      iconSrc: NumericalIcon,
      description: `projects.settings.fields.constraints.max_delivery_time.description`,
    },
    reward: {
      iconSrc: NumericalIcon,
    },
    cluster: {
      iconSrc: TextIcon,
    },
  };
};
